import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getReportFolders,
  createReportFolder,
  updateReportFolder,
  deleteReportFolder,
} from "../api";
import { useNotification } from "../../../contexts/NotificationContext";

export const useGetReportFolders = (params = {}, options = {}) => {
  const { enabled = true } = options;
  return useQuery({
    queryKey: ["report-folders", params],
    queryFn: () => getReportFolders(params),
    enabled,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};

export const useCreateReportFolder = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: (data) => createReportFolder(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["report-folders"] });
      showNotification("success", "Folder created successfully");
    },
    onError: () => {
      showNotification("danger", "Failed to create folder");
    },
  });
};

export const useUpdateReportFolder = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: ({ id, data }) => updateReportFolder(id, data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["report-folders"] });
      showNotification("success", "Folder updated successfully");
    },
    onError: () => {
      showNotification("danger", "Failed to update folder");
    },
  });
};

export const useDeleteReportFolder = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: (id) => deleteReportFolder(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["report-folders"] });
      showNotification("success", "Folder deleted successfully");
    },
    onError: () => {
      showNotification("danger", "Failed to delete folder");
    },
  });
};
